import { render, staticRenderFns } from "./novo_usuario_prefeitura.vue?vue&type=template&id=b3e2d2d4&scoped=true&"
import script from "./novo_usuario_prefeitura.vue?vue&type=script&lang=js&"
export * from "./novo_usuario_prefeitura.vue?vue&type=script&lang=js&"
import style0 from "./novo_usuario_prefeitura.vue?vue&type=style&index=0&id=b3e2d2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e2d2d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VRadio,VRadioGroup,VSelect,VTextField})
